import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { Card } from "reactstrap";

import { ReactComponent as BackArrow } from "../../../../../../../assets/img/svg/BackArrow.svg";
import AButton from "../../../../common/form-fields-mui/AButton";
import ListComponent from "./ListComponent";
import {
  fetchAllPostPromisedData,
  checkPermission,
} from "../../../../common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "../../../../common/constant";
import { getAllActiveBusinessArea } from "../../paymentGatewaysConfiguration/common";
import {
  failureToast,
  successToast,
} from "../../../../common/utils/methods/toasterFunctions/function";
import FilterForm from "./FilterForm";
import APopover from "../../../../common/a-popover";
import SearchInput from "../../../onlinePackage/SearchInput";
import { machineTypes, vendorTypes } from "./common";

const PosMappingListing = ({ userPermissions }) => {
  const history = useHistory();
  const ref = useRef();

  const isCreatePermission = checkPermission(userPermissions, "C");
  const isUpdatePermission = checkPermission(userPermissions, "U");

  const masterDropdowns = useSelector(
    (state) => state.globalData.masterDropdowns
  );
  const [allActiveBusinessAreas, setAllActiveBusinessAreas] = useState([]);
  const [allBusinessArea, setAllBusinessArea] = useState([]);
  const [posMappingData, setPosMappingData] = useState([]);
  const [loading, setLoading] = useState([]);
  const [paginationInfo, setPaginationInfo] = useState({
    currentPage: 0,
    totalRecords: 0,
  });
  const [filterForm, setFilterForm] = useState({});

  const getPosMappings = async (
    filterObj = {},
    pageNumber = 0,
    allBUs = allBusinessArea
  ) => {
    try {
      const updatedFilterObj = {
        ...filterObj,
        ...(!filterObj?.businessAreaIds?.length && {
          businessAreaIds: allBUs?.map((bu) => bu.value),
        }),
      };
      setLoading(true);
      const resp = await fetchAllPostPromisedData(
        `${endpoint.posMapping.search}?offset=${pageNumber}`,
        updatedFilterObj,
        "post"
      );
      if (resp?.code === 200) {
        const updatedData = resp.data.posMappingDtoList?.map((el) => ({
          ...el,
          businessArea: allBUs?.find((bu) => bu.value === el.businessAreaId),
          type: machineTypes?.find((type) => type.value === el.machineType),
          vendorType: vendorTypes?.find(
            (type) => type.value === el?.vendorType
          ),
        }));
        setPosMappingData(updatedData);
        setPaginationInfo({
          totalRecords: resp.data.totalRecords,
          currentPage: resp.data.currentPage,
        });
        ref.current.stopEditing();
      }
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  const getFilterCount = () => {
    const { businessArea, status, vendorType } = filterForm;
    let count = 0;

    if (businessArea?.length) count++;
    if (!!status) count++;
    if (!!vendorType) count++;

    return count;
  };

  const createUpdateHandler = async (rowForm) => {
    if (!rowForm?.vendorType?.label)
      return failureToast("Please select a vendor type");
    try {
      setLoading(true);
      const reqObj = {
        ...rowForm,
        businessAreaId: rowForm.businessArea?.id,
        businessAreaValue: rowForm.businessArea?.businessAreaKey,
        machineType: rowForm.type?.value,
        vendorType: rowForm.vendorType?.value,
      };
      let url = endpoint.posMapping.create;
      let method = "post";

      if (!rowForm?.isNew) {
        url = `${endpoint.posMapping.update}/${reqObj?.id}`;
        method = "put";
      }
      const resp = await fetchAllPostPromisedData(url, reqObj, method);
      if (resp?.code === 200) {
        getPosMappings();
        successToast("Request completed successfully!!!");
        ref.current.stopEditing();
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const pageChangeHandler = (newPage) => {
    applyFilterHanlder(newPage);
  };

  const handleFilterForm = (value, key) => {
    setFilterForm((prev) => ({ ...prev, [key]: value }));
  };

  const applyFilterHanlder = (pageNumber = 0) => {
    const { businessArea, status, vendorType } = filterForm;
    const filterObj = {
      ...(businessArea && {
        businessAreaIds: businessArea?.map((bu) => bu.value),
      }),
      ...(status && { status: status?.value }),
      ...(vendorType && { vendorType: vendorType?.value }),
    };
    setFilterForm((prev) => ({
      ...prev,
      appliedFilterCount: getFilterCount(),
    }));

    getPosMappings(filterObj, pageNumber);
  };

  const removeFilterHandler = () => {
    getPosMappings();
    setFilterForm({});
  };

  const searchHandler = (inputVal) => {
    const newFilterObj = inputVal ? { userId: inputVal } : {};
    setFilterForm({});
    getPosMappings(newFilterObj);
  };

  const cancelSearchHandler = () => {
    getPosMappings(filterForm);
  };

  const init = async () => {
    setLoading(true);
    const buDropdown = masterDropdowns?.allBusinessAreaList.map(
      ({ label, businessAreaId, ...props }) => ({
        ...props,
        label,
        value: businessAreaId,
        id: businessAreaId,
        businessAreaKey: label,
      })
    );
    setAllBusinessArea(buDropdown);

    const allActiveBu = await getAllActiveBusinessArea();
    setAllActiveBusinessAreas(allActiveBu);

    getPosMappings({}, 0, buDropdown);
  };

  useEffect(() => {
    init();
  }, []);

  return (
    <>
      <Card className="mx-2">
        <div className="d-flex justify-content-between my-3 mx-2">
          <div className="d-flex justify-content-between">
            <BackArrow
              className="color-black mr-2 cursor"
              onClick={() => history.goBack()}
            />
            <h4 className="color-black">POS Mapping</h4>
          </div>
          <div className="d-flex justify-content-between">
            <SearchInput
              inputStyles={{ border: "1px solid #000" }}
              placeholder={"Search by User ID"}
              searchInputValueHandler={searchHandler}
              onCancel={cancelSearchHandler}
            />
            <APopover
              buttonComponent={(openPopover) => (
                <AButton variant="outline" onClick={openPopover} size="xs">
                  Filter
                  {filterForm?.appliedFilterCount > 0
                    ? `(${filterForm?.appliedFilterCount})`
                    : ""}
                </AButton>
              )}
              menuComponent={(closePopup) => (
                <FilterForm
                  businessAreaDropdown={allBusinessArea}
                  form={filterForm}
                  applyFilterHandler={applyFilterHanlder}
                  handleFilterForm={handleFilterForm}
                  closePopup={closePopup}
                  removeFilterHandler={removeFilterHandler}
                  filterCount={getFilterCount()}
                />
              )}
            />
            {isCreatePermission && (
              <AButton
                variant="primary_filled"
                onClick={() => ref.current.addNewRow()}
                size="xs"
              >
                + Add new POS mapping
              </AButton>
            )}
          </div>
        </div>

        <ListComponent
          rows={posMappingData}
          ref={ref}
          businessAreaDropdown={allActiveBusinessAreas}
          createUpdateHandler={createUpdateHandler}
          loading={loading}
          currentPage={paginationInfo.currentPage}
          totalRecords={paginationInfo.totalRecords}
          pageChangeHandler={pageChangeHandler}
          setLoading={setLoading}
          isUpdatePermission={isUpdatePermission}
        />
      </Card>
    </>
  );
};

export default PosMappingListing;
